import _ from 'underscore';

const legacyDependencies = [
  'AdScheduleView',
  'AlertHelper',
  'AudienceAdgroupSettingsWizard',
  'BaseTargetUpdateView',
  'BiddableAdGroupCriterion',
  'BiddableCampaignCriterion',
  'BulkAdapter',
  'CampaignAdgroupSelectorControl',
  'CampaignCacheManager',
  'CampaignSchema',
  'ChangeStatusModel',
  'ChangeStatusView',
  'ChangeUrlOptionsModel',
  'ChangeUrlOptionsView',
  'ChangeRsaAutoAssetsModel',
  'ChangeRsaAutoAssetsView',
  'Columns',
  'DownloadView',
  'InlineBudgetEditor',
  'InlineSharedBudgetEditor',
  'LegacyColumns',
  'LegacySelectedColumns',
  'LocationMap',
  'LocationTargets',
  'ODataConverter',
  'Picker',
  'SelectedColumns',
  'appendPeriodOverPeriodFields',
  'bidAdjustmentBulkEditPlugin',
  'campaignStatus',
  'config',
  'constants',
  'criterionLoader',
  'decimal',
  'editAdGroupPage',
  'editCampaignPage',
  'editShoppingCampaignPage',
  'editSmartShoppingCampaignPage',
  'edmCampaign',
  'eventDispatcher',
  'fetchPreferenceConfig',
  'filterOptionsFromSchema',
  'filterPlugin',
  'filterStatePlugin',
  'getAccountTimeZoneText',
  'getTimeZoneForDateRangeText',
  'handleSortChange',
  'httpUtils',
  'i18n',
  'i18nErrors',
  'inlineChartPlugin',
  'isDeprecatedLocation',
  'jsDataCampaign',
  'locationConstants',
  'locationTargetConverter',
  'locationTargetStatusPopup',
  'logger',
  'odataOptions',
  'pageContext',
  'preferencesService',
  'quickFilterPlugin',
  'recommendationRepository',
  'removeBulkEditPlugin',
  'router',
  's$AdGroupCriterion',
  's$CampaignCriterion',
  's$NegativeAdGroupCriterion',
  's$NegativeCampaignCriterion',
  's$i18n',
  'segmentPreference',
  'sessionStorage',
  'state',
  'targetConstants',
  'targetTypes',
  'unitMaps',
  'updateFilterSchemaForPilotFeatures',
  'fetchPaginationConfig',
  'segmentTimeChecker',
];

export class TargetingSettingsContext {
  static initialize({ deps }) {
    _.extend(TargetingSettingsContext, deps);
  }

  static isInitialized() {
    const missingDependencies = [];
    _.each(legacyDependencies, (dependency) => {
      const missing = _.isUndefined(TargetingSettingsContext[dependency]);
      if (missing) {
        missingDependencies.push(dependency);
      }
    });

    if (missingDependencies.length > 0) {
      throw new Error(`Dependent modules ${missingDependencies.toString()} are not injected.`);
    }
    return true;
  }
}
